import {
  GET_SHIPPING_CONTACT,
  GET_SHIPPING_CONTACT_SUCCESS,
  GET_SHIPPING_CONTACT_FAIL,
  GET_SHIPPING_CONTACT_BY_ID_SUCCESS,
} from "./actionTypes.js";
const initState = {
  items: [],
  item: null,
  error: null,
  itemCount: 0,
  pageCount: 0,
  loading: false,
};

const ShippingContact = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_SHIPPING_CONTACT:
      return {
        ...state,
        loading: true,
      };
    case GET_SHIPPING_CONTACT_SUCCESS:
      const { itemCount, pageCount, data } = payload;
      return {
        ...state,
        itemCount,
        pageCount,
        items: data,
        loading: false,
      };
    case GET_SHIPPING_CONTACT_BY_ID_SUCCESS:
      return {
        ...state,
        item: payload,
      };
    case GET_SHIPPING_CONTACT_FAIL:
      return {
        ...state,
        error: payload,
      };
    default:
      return state;
  }
};

export default ShippingContact;
